module.exports = __webpack_public_path__ + "static/media/hero-image.d5d8977e.png";